// extracted by mini-css-extract-plugin
export var attachment = "_ql-a";
export var emailContainer = "_ql-4";
export var emailContentPaddedContainer = "_ql-b";
export var emailHeader = "_ql-6";
export var emailIframe = "_ql-3";
export var emailInfoIcon = "_ql-9";
export var emailShortenedSummary = "_ql-e";
export var infoDropdown = "_ql-0";
export var infoRowBoundedContent = "_ql-d";
export var internal = "_ql-5";
export var merchant = "_ql-8";
export var messageInputContainer = "_ql-h";
export var normal = "_ql-7";
export var replyCard = "_ql-f";
export var subtleButton = "_ql-1";
export var subtleButtonIconContainer = "_ql-2";
export var toggleViewRepliesButton = "_ql-c";
export var wrappingText = "_ql-g";